import React from "react";
import { Row, Col, Form, Select, Input, Button, DatePicker } from "antd";
import { SPLIT_TYPE_OPTIONS } from "@/constants/util";

const DATE_FORMAT = "YYYY-MM-DD";

const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

const Option = Select.Option;

const Search = (props) => {
  const { form, onSearch = () => {},onExport=()=>{} } = props;

  const handleSubmit = () => {
    form.validateFields((err, values) => {
      if (!err) {
        if (values.time && Array.isArray(values.time)) {
          values.beginTime = values.time?.[0]?.format(DATE_FORMAT);
          values.endTime = values.time?.[1]?.format(DATE_FORMAT);
          delete values.time;
        }
        onSearch(values);
      }
    });
  };

  const handleExport=()=>{
    onExport()
  }

  return (
    <div className="pl-24 pr-24 bg-white pt-16 pb-16 bd-line mt-16">
      <Row>
        <Col span={20}>
          <Form layout="inline">
            <Form.Item>
              {form.getFieldDecorator("time", {})(<RangePicker />)}
            </Form.Item>
            <Form.Item>
              {form.getFieldDecorator(
                "type",
                {}
              )(
                <Select style={{ width: 128 }} placeholder="分账类型">
                  {SPLIT_TYPE_OPTIONS.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" onClick={handleSubmit}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </Col>
        <Col span={2} align="right">
          <Button type="primary" onClick={handleExport}>
            导出
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default Form.create()(Search);
